var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"client_logo",attrs:{"id":"client_logo"}},[_c('a',{style:('background-image: url('+_vm.logoLight+')'),attrs:{"href":_vm.client.Website,"target":"_blank"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }